import React from 'react'
import PropTypes from 'prop-types'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from './_AdviserNameSearch.scss'
import { connect } from 'react-redux'
import { actions } from '../../../features/AdviserSearchResultsListContainer/adviserSearchResultsListContainerActions'
import FieldGroup from '../../forms/FieldGroup'
import { bindActionCreators } from 'redux'
import SearchButton from '../../Buttons/SearchButton'
import { Row, Col } from 'react-bootstrap'
import classNames from 'classnames'
import 'bootstrap/dist/css/bootstrap.min.css';

function handleKeyPress (event, findIfa, ifaName, pageSize) {
  if (event.key === 'Enter') {
    event.preventDefault()
    if (ifaName.length === 0) return
    findIfa(ifaName, null, pageSize)
  }
}

function AdviserNameSearch ({
    findIfa, setIfaName, ifaName, placeHolder, pageSize, setResultsDirty
  }) {
  return (
    <Row>
      <Col className={classNames(styles['search-container'], 'd-none', 'd-md-block')} md={12} lg={12}>
        <div className={classNames(styles['search-inner'], 'd-flex', 'align-items-center')}>
          <FieldGroup
            data-qa="Textbox-adviserName"
            fieldGroupClass={styles['input-width']}
            value={ifaName}
            handleChange={(value) => {
              setIfaName(value)
              setResultsDirty()
            }}
            handleKeyPress={(event) =>
              handleKeyPress(event, findIfa, ifaName, pageSize)
            }
            placeholder={placeHolder || "Search advisers"}
          />
          <SearchButton
            data-qa="Search-button"
            handleClick={() => findIfa(ifaName, null, pageSize)}
            disabled={ifaName.length === 0}
            buttonClassName={`${styles['float-right']} ms-2`}
          />
        </div>
      </Col>

      <Col xs={12} className={classNames(styles['search-container'], 'd-block', 'd-md-none')}>
        <div className={classNames(styles['search-inner'], 'd-flex', 'align-items-center')}>
          <FieldGroup
            data-qa="Textbox-adviserName"
            fieldGroupClass={styles['input-width']}
            value={ifaName}
            handleChange={(value) => setIfaName(value)}
            handleKeyPress={(event) =>
              handleKeyPress(event, findIfa, ifaName, pageSize)
            }
            placeholder={placeHolder || "Search advisers"}
          />
          <SearchButton
            data-qa="Search-button"
            size="large"
            handleClick={() => findIfa(ifaName, null, pageSize)}
            disabled={ifaName.length === 0}
            buttonClassName={`${styles['mobile-search-button']} ms-2`}
          />
        </div>
      </Col>
    </Row>
  )
}

AdviserNameSearch.propTypes = {
  findIfa: PropTypes.func.isRequired,
  setResultsDirty: PropTypes.func.isRequired,
  setIfaName: PropTypes.func.isRequired,
  ifaName: PropTypes.string.isRequired,
  placeHolder: PropTypes.string,
  pageSize: PropTypes.number.isRequired
}

const mapStateToProps = function (state) {
  return {
    ifaName: state.searchResults.searchBar.ifaName,
    adminLoggedIn: state.administrationLoginContainer.loginSucceeded
  }
}

const mapDispatchToProps = function (dispatch) {
  return bindActionCreators({
    findIfa: actions.fetch.findIfaByNameResults,
    setIfaName: actions.set.ifaName,
    setResultsDirty: actions.set.resultsRefreshed
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(AdviserNameSearch)
